<template>
  <div class="app-container">
    <div class="index-tree-box">
      <div class="left-box" style="height: calc(100vh - 124px)">
        <div class="left-title">
          <span>参数类型</span>
        </div>
        <div class="left-main m-scroll">
          <tree ref="tree" @select="onSelect" height="500px" />
        </div>
      </div>
      <div class="right-box">
        <info ref="info"></info>
      </div>
    </div>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import info from "@/components/sys/setting/info";
import tree from "@/components/sys/setting/tree";

export default {
  name: "setting",
  components: {
    info,
    tree,
  },
  mounted() {
    this.$refs.tree.init();
  },
  methods: {
    onSelect(data) {
      this.$refs.info.setData(data);
    },
  },
};
</script>